<span class="tag__icon" [ngClass]="icon" *ngIf="icon"></span>
<span class="tag__text">{{value}}</span>
<span class="tag__icon-close icon-close" *ngIf="showDeleteButton" (click)="onDelete.emit()"></span>
